import { render } from "./FullScreenModal.vue?vue&type=template&id=6fdc36d6"
import script from "./FullScreenModal.vue?vue&type=script&lang=js"
export * from "./FullScreenModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__